import React, { useEffect }  from 'react';
import styled from 'styled-components';
import { IconCalling } from '../../Assets/contacts/IconCalling';
import { Dictionery } from '../../Data/Dictionery';
import { IconSMS } from '../../Assets/contacts/IconSMS';
import { IconBuilding } from '../../Assets/contacts/IconBuilding';
import { IconInstagram } from '../../Assets/contacts/IconInstagram';
import { IconFacebook } from '../../Assets/contacts/IconFacebook';
import { IconYoutube } from '../../Assets/contacts/IconYoutube';
import { IconPhone } from '../../Assets/contacts/IconPhone';
import { setMetaTags } from '../Functions/SetHeaders';
const Styles = styled.div`
  margin: 0 0 0.5rem;
  .back-drop {
    width: 100%;
    height: 30vh;
    height: 30lvh;
    overflow: hidden;
    border-radius:0 0 var(--border-radius-3) var(--border-radius-3);
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    margin-bottom: -5vh;
    margin-bottom: -5lvh;
  }
  .over-agency {
    width: calc(100% - calc(var(--universal-pad) * 2) - 4rem);
    margin: 0 var(--universal-pad) 1rem;
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 1.25rem 2rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .base {
      display: flex;
      align-items: flex-end;
      gap: 0.2rem;
      .title1 {
        font-size: 1.5rem;
        font-weight: 700;
      }
      .title2 {
        font-size: 0.9rem;
        font-weight: 700;
      }
    }
    .image {
      position: absolute;
      top: -60px;
      left: calc(50% - 50px);
      width: 100px;
      height: 100px;
      background-color: #6ABBAB;
      border: 1px solid var(--n-grey-1);
      border-radius: 1000px;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .end {
      display: flex;
      justify-content: flex-end;
      gap: 1.25rem;
      .social {
        border-radius: 100px;
        border: 1px solid var(--n-grey-1);
        background-color: var(--n-grey-01);
        padding: 0.87rem;
        svg {
          display: block;
        }
      }
    }
  }
  .over-desc {
    width: calc(100% - calc(var(--universal-pad) * 2) - 5rem);
    margin: 1rem var(--universal-pad);
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 2rem 2.5rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 0.5rem;
    white-space: pre-wrap;
  }
  .over-detail {
    width: calc(100% - calc(var(--universal-pad) * 2) - 5rem);
    margin: 0 var(--universal-pad);
    background-color: var(--n-grey-0);
    box-shadow: 0px 4px 50px -16px #00000028;
    padding: 2rem 2.5rem;
    border-radius: var(--border-radius-32);
    position: relative;
    display: flex;
    justify-content: space-between;
    gap: 1.25rem;
    .data {
      flex-grow: 1;
      width: 50%;
      display: flex;
      flex-direction: column;
      .row {
        display: flex;
        justify-content: space-between;
        padding: 1rem 0;
        align-items: center;
      }
      .column {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 1rem 0;
      }
      .line-vertical {
        height: 1px;
        background-color: var(--n-grey-1);
      }
      .title {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .text {
          font-weight: 600;
          color: var(--n-grey-2);
        }
      }
      .desc {
        white-space: pre-wrap;
        font-weight: 600;
        .socials {
          display: flex;
          justify-content: flex-end;
          gap: 1.25rem;
          .social {
            border-radius: 100px;
            border: 1px solid var(--n-grey-1);
            background-color: var(--n-grey-01);
            padding: 0.87rem;
            svg {
              display: block;
            }
          }
        }
      }
    }
    .image {
      flex-grow: 1;
      width: 50%;
      /* height: 100%; */
      background-color: var(--n-grey-2);
      border-radius: var(--border-radius-3);
      overflow: hidden;
      position: relative;
      img {
        position: absolute;
        inset: 0;
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  @media screen and (max-width: 850px) {
    .over-agency {
      flex-direction: column;
      gap: 1rem;
      .base {
        margin-top: 2rem;
      }
    }
    .over-desc {
      width: calc(100% - calc(var(--universal-pad) * 2) - 2rem);
      padding: 2rem 1rem;
    }
    .over-detail {
      flex-direction: column;
      width: calc(100% - calc(var(--universal-pad) * 2) - 2rem);
      padding: 2rem 1rem 1rem;
      .data {
        width: 100%;
      }
      .image {
        width: 100%;
        aspect-ratio: 1.5;
      }
    }
  }
`
export default function AgencyMain14 (props){
  const {data: dataRaw, lan, agency} = props;
  const data = JSON.parse(dataRaw);
  useEffect(() => {
    setMetaTags("Luxintrip", "", "noindex");
  }, []);
  useEffect(() => {
    setMetaTags("Luxintrip", "", "noindex");
  }, [agency]);
  const makeData = (icon, title, data, className) => {
    return (
      <div className={className}>
        <div className='title'>
          {
            (icon) ? (
              <div className='icon'>
                {icon}
              </div>
            ) : ""
          }
          
          <div className='text'>
            {title}
          </div>
        </div>
        <div className='desc'>
          {data}
        </div>
      </div>
    )
  }
  const makeLink = (link, type) => {
    if(link){
      switch(type){
        case "instagram":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconInstagram/>
            </a>
          )
        case "facebook":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconFacebook/>
            </a>
          )
        case "youtube":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconYoutube/>
            </a>
          )
        case "tell":
          return (
            <a className='social' href={link} target='_blank' rel="noreferrer">
              <IconPhone/>
            </a>
          )
        default:
          return;
      }
    }
    return;
  }
  return (
    <Styles>
      <div className='back-drop'>
        <img src={agency.Agency_Picture} alt='background'/>
      </div>
      <div className='over-agency'>
        <div className='base'>
          <h1 className='title1'>
            {agency.Agency_Name}
          </h1>
        </div>
        <div className='image'>
          <img src={agency.Agency_Logo} alt={agency.Agency_Name}/>
        </div>
        <div className='end'>
          {makeLink("tel:" + agency.Agency_Tel_no.replace("-", ""), "tell")}
          {makeLink(data.insta, "instagram")}
          {makeLink(data.facebook, "facebook")}
          {makeLink(data.youtube, "youtube")}
        </div>
      </div>
      <pre className='over-desc'>
        {agency.Agency_Desc}
      </pre>
      <pre className='over-detail'>
        <div className='data'>
            {makeData(<IconCalling/>, Dictionery.call[lan.filename], agency.Agency_Tel_no, "row")}
          <div className='line-vertical'></div>
            {makeData(<IconSMS/>, Dictionery.email[lan.filename], agency.Agency_Email, "row")}
          <div className='line-vertical'></div>
            {makeData(<IconBuilding/>, Dictionery.address[lan.filename], agency.Agency_Address, "column")}
          <div className='line-vertical'></div>
            {makeData(null, Dictionery.communication[lan.filename],(
              <div className='socials'>
                {makeLink("tel:" + agency.Agency_Tel_no.replace("-", ""), "tell")}
                {makeLink(data.insta, "instagram")}
                {makeLink(data.facebook, "facebook")}
                {makeLink(data.youtube, "youtube")}
              </div>
            ), "row")}
        </div>
        <div className='image'>
          <img src={agency.Agency_Picture} alt='location agency'/>
        </div>
      </pre>
    </Styles>
  )
}

